import { useEffect, useRef, useContext } from "react";
import "../styles/myStats.css";
import "../styles/player.css";
import TypewriterText from "../components/TypewriterText";
import { RpgModeContext } from "../RpgModeContext.js";

const Player = () => {
  const scrollRef = useRef(null);
  const typewriterRef = useRef(null);
  const { rpgMode } = useContext(RpgModeContext);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, []);

  return (
    <div
      id="myPlayer"
      className="dialog-box dialog-box--player"
      onClick={() => {
        if (typewriterRef.current?.skipTyping) {
          typewriterRef.current.skipTyping();
        }
      }}
    >
      <div className="dialog-content-wrapper">
        <div className="dialog-content" ref={scrollRef}>
          <p>
            <TypewriterText
              ref={typewriterRef}
              text={rpgMode ? `Welcome, traveler.

I’m Nathaniel Gomez — senior full-stack engineer and 2D illustrator specializing in high-performance product systems, scalable front-end architecture, and production optimization.

Over the last year at Unit Network, I shipped across the main app, wallet, ramp, indexer, and multiple production dApps — delivering end-to-end features, operational tooling, security improvements, and large-scale performance optimizations across both frontend and backend systems.

My work includes reducing critical loading operations from 60–70 seconds down to ~3 seconds, minimizing 1000+ blockchain queries into batched server-side flows, improving indexer throughput by 40–50×, and hardening sensitive payment and authorization systems before production release.

I work best where engineering, product sense, and execution meet — building systems that are not only functional, but fast, maintainable, and reliable under real production pressure.

Before this guild, I led webtoon production teams at GIGA Studio and built OCR/mobile automation systems during my early engineering years. I still draw when the story calls for it.

Currently seeking the next meaningful quest.\n\n\n` :
`Hello!

I’m Nathaniel Gomez, a senior full-stack engineer focused on scalable frontend systems, APIs, and production optimization.

At Unit Network, I shipped across the main app, wallet, ramp, indexer, and multiple production dApps — delivering end-to-end features, operational tooling, security improvements, and measurable performance wins across both frontend and backend systems.

My work includes reducing critical loading operations from 60–70 seconds down to ~3 seconds, reducing 1000+ blockchain queries into batched server-side flows, improving indexer throughput by 40–50×, and hardening sensitive payment and authorization systems before production deployment.

I specialize in React, Next.js, TypeScript, Node.js, and production-focused engineering workflows with strong emphasis on performance, reliability, and maintainable system design.

Before transitioning fully into engineering, I led webtoon production teams at GIGA Studio and worked on automation-focused mobile/OCR systems. I still continue illustration work as a creative outlet alongside software development.

Open to opportunities where engineering, product thinking, and system optimization intersect.

Let’s connect!\n\n\n`}
            />
          </p>
        </div>
      </div>
      <span id="myDialogPrompt" className="dialog-prompt">
        ▼
      </span>
    </div>
  );
};

export default Player;
